export const optionButtonSx = {
  textTransform: "none",
  justifyContent: "flex-start",
  gap: 1.5,
  py: 1.5,
  px: 2,
  borderRadius: 2,
  bgcolor: "#f5f5f5",
  border: "1px solid",
  borderColor: "grey.200",
  color: "grey.800",
  "&:hover": {
    bgcolor: "grey.100",
    borderColor: "grey.300",
  },
};

export const selectedOptionSx = {
  borderColor: "#8DE038",
  borderWidth: 1,
  bgcolor: "rgba(141, 224, 56, 0.12)",
  "&:hover": {
    bgcolor: "rgba(141, 224, 56, 0.18)",
    borderColor: "#8DE038",
  },
};

export const cancelButtonSx = {
  minWidth: 100,
  borderRadius: "9999px",
  fontSize: 15,
  fontWeight: 500,
  color: "black",
  border: "none",
  textTransform: "none",
  "&:hover": {
    color: "black",
    bgcolor: "#CDCDCD",
  },
};

export const primaryButtonSx = {
  minWidth: 100,
  borderRadius: "9999px",
  fontSize: 15,
  fontWeight: 500,
  bgcolor: "#1B1B1D",
  textTransform: "none",
  "&:hover": {
    bgcolor: "#A5F455",
    color: "black",
  },
  "&:active": { transform: "scale(0.95)" },
};

export const linkInputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "9999px",
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "grey.300" },
  },
};

export const quickNoteTextAreaClass =
  "scrollbar-hidden min-h-[250px] w-full resize-y overflow-y-auto bg-transparent p-6 text-[15px] leading-[1.6] text-[#1d1d1f] outline-none placeholder:text-gray-300";

export const quickNoteWrapperClass = "mb-4";
export const quickNoteOuterClass = "min-h-[280px] rounded-[28px] bg-[#EDEDED] p-3";
export const quickNoteInnerClass =
  "min-h-[250px] rounded-[24px] bg-[#F8F8F8] shadow-[inset_0_1px_2px_rgba(0,0,0,0.04)]";

export const formPanelClass = "rounded-xl border border-gray-200 bg-gray-50 p-4";
export const formActionsClass = "flex items-center justify-end gap-3 pt-1";
export const formTitleClass = "mb-2 font-medium text-gray-800";
export const formSubtitleClass = "mb-0.5 font-semibold text-gray-900";
export const formSubtitleSecondaryClass = "body2 text-secondary mb-3";
